import { useMutation } from "@tanstack/react-query";
import { api } from "../../lib/api";

export function useDeleteEverifyUser() {
  return useMutation({
    mutationFn: async ({ userId, companyId }) => {
      const { data } = await api.delete(`/user/deleteuser/${userId}/${companyId}`, {
        headers: { "x-company-id": String(companyId) },
      });
      return data;
    },
  });
}
